// FloatingTotals.jsx
import React, { useMemo, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { threeDecimal, twoDecimal } from "../../config/helperFunctions";

const toNum = (v) => {
  if (v === undefined || v === null) return 0;
  const s = String(v).replace(/,/g, "").trim();
  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
};

const pick = (row, keys) => {
  for (const k of keys) {
    if (row && row[k] !== undefined && row[k] !== null && row[k] !== "") {
      return row[k];
    }
  }
  return 0;
};

const fmtINR2 = (n) =>
  new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(toNum(n));

const fmtINR = (n) => new Intl.NumberFormat("en-IN", { maximumFractionDigits: 3 }).format(n);

export default function FloatingTotals({
  items = [],
  fieldsMap = {
    qty: ["Qty", "qty", "Quantity", "quantity", "QTY"],
    totalWt: ["totalWt"],
    packingWt: ["packingWt"],
    gross: ["GrossWeight", "grossWeight", "GrossWt", "grossWt"],
    net: ["NetWeight", "netWeight", "NetWt", "netWt"],
    stone: ["StoneWeight", "stoneWeight", "StoneWt", "stoneWt"],
    diamond: ["diamondWt"],
    itemFineMakingWt: ["itemFineMakingWt"],
  totalItemAmount: ["totalItemAmount", "TotalItemAmount", "TotalAmount", "totalAmount", "Amount", "amount"],
  },
}) {
  const [open, setOpen] = useState(false);

  
  const totals = useMemo(() => {
    return items.reduce(
      (acc, row) => {
        acc.items += 1;
        acc.qty += toNum(pick(row, fieldsMap.qty));
        acc.totalWt += toNum(pick(row, fieldsMap.totalWt));
        acc.packingWt += toNum(pick(row, fieldsMap.packingWt));
        acc.gross += toNum(pick(row, fieldsMap.gross));
        acc.net += toNum(pick(row, fieldsMap.net));
        acc.stone += toNum(pick(row, fieldsMap.stone));
        acc.diamond += toNum(pick(row, fieldsMap.diamond));
        acc.itemFineMakingWt += toNum(pick(row, fieldsMap.itemFineMakingWt));
        acc.totalItemAmount += toNum(pick(row, fieldsMap.totalItemAmount));
        return acc;
      },
      { items: 0, qty: 0,totalWt:0,packingWt:0, gross: 0, net: 0, stone: 0,diamond:0,itemFineMakingWt:0,  totalItemAmount: 0 }
    );
  }, [items, fieldsMap]);

  return (
    <>
      {/* FAB */}
      <button
        type="button"
        aria-label="Show totals"
        onClick={() => setOpen((v) => !v)}
        className="absolute bottom-6 right-4 z-50 rounded-full shadow-lg bg-[#9481ce] text-white p-4 hover:scale-105 active:scale-95 transition"
      >
        <motion.svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="20"
          height="20"
          className="block"
          animate={{ rotate: open ? 180 : 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
        >
          <path d="M7 5h12M5 12h10M7 19h12" />
        </motion.svg>
      </button>

      {/* Right-to-left ROLL-OUT strip */}
      <AnimatePresence>
        {open && (
          <motion.div
            // roll from right-edge: scaleX 0 -> 1
            initial={{ scaleX: 0, opacity: 0 }}
            animate={{ scaleX: 1, opacity: 1 }}
            exit={{ scaleX: 0, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
            className="absolute bottom-5 right-20 z-50 origin-right overflow-hidden  rounded-xl border-none bg-[#9481ce] text-white shadow-2xl"
          >
            {/* content slight slide for polish */}
            <motion.div initial={{ x: 16, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ delay: 0.05 }}>
              <div className="px-4 py-2">
                <div className="text-xs text-white/90 mb-1">Totals</div>
                <div className="flex items-center gap-2 md:gap-5 overflow-x-auto whitespace-nowrap text-xs ">
                  <span className="px-2 py-1 rounded bg-white/90 text-gray-800">Items: {fmtINR(totals.items)}</span>
                  <span>Qty: {fmtINR(totals.qty)}</span>
                  <span>Total Wt: {threeDecimal(fmtINR(totals.totalWt))}</span>
                  <span>Packing Wt: {threeDecimal(fmtINR(totals.packingWt))}</span>
                  <span>Gross Wt: {threeDecimal(fmtINR(totals.gross))}</span>
                  <span>Net Wt: {threeDecimal(fmtINR(totals.net))}</span>
                  <span>Stone Wt: {threeDecimal(fmtINR(totals.stone))}</span>
                  <span>Diamond Wt: {threeDecimal(fmtINR(totals.diamond))}</span>
                  <span>Fine Wt: {threeDecimal(fmtINR(totals.itemFineMakingWt))}</span>
<span>Item Amount: ₹{fmtINR2(totals.totalItemAmount)}</span>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
